import { dashboardRoute, routes } from '../constants/routes';
import { IMWCommonMenuView, TConcreteRouteGroup } from '../models/navigation';

export const findLongestPrefix = (
  links: { path: string }[],
  currentPage: string,
): string => {
  let longestPrefix = '';
  links.forEach(({ path }) => {
    if (currentPage.startsWith(path) && path.length > longestPrefix.length) {
      longestPrefix = path;
    }
  });
  return longestPrefix;
};

export const mapMainMenuToCommonView = (
  menu: TConcreteRouteGroup[],
): IMWCommonMenuView[] => {
  if (!menu || !Array.isArray(menu)) {
    return [];
  }

  let commonMenu: IMWCommonMenuView[] = menu.map((link) => {
    return { path: '#', label: link.title, icon: link.icon, links: link.links };
  });

  commonMenu = [
    {
      path: routes.dashboard.path,
      label: dashboardRoute.title,
      icon: dashboardRoute.icon,
      links: null,
    },
    ...commonMenu,
  ];

  return commonMenu;
};

export const mapSubmenuToCommonView = (
  menu: TConcreteRouteGroup[],
  currentMenuTitle: string,
): IMWCommonMenuView[] => {
  const foundItem = menu.find((item) => item.title === currentMenuTitle);

  if (!foundItem || !Array.isArray(foundItem.links)) {
    return [];
  }

  const { links }: TConcreteRouteGroup = foundItem;

  const commonMenu = links
    .filter((link) => link.shouldShow)
    .map((link) => {
      return { path: link.path, label: link.label, icon: null, links: null };
    });

  return commonMenu;
};
